import { render, staticRenderFns } from "./EmailTemplateCreate.vue?vue&type=template&id=2526a3d0&"
import script from "./EmailTemplateCreate.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports